/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { DebugSendWelcomeEmailOptions, DebugSendWelcomeEmailResponses } from '../../models/DebugSendWelcomeEmail'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Queue a welcome email for a given user.
 * @summary Send Welcome Email
 * {@link /admin/debug/send-welcome-email}
 */
export function debugSendWelcomeEmail<ThrowOnError extends boolean = true>(options: Options<DebugSendWelcomeEmailOptions, ThrowOnError>): Promise<UnwrappedResult<DebugSendWelcomeEmailResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/debug/send-welcome-email', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<DebugSendWelcomeEmailResponses, ThrowOnError>>
}
